export default {
  getAll: {
    url: '/api/menu/getAll',
    method: 'get'
  },
  getTree: {
    url: '/api/menu/getTree',
    method: 'get'
  },
  create: {
    url: '/api/menu/create',
    method: 'post'
  },
  update: {
    url: '/api/menu/update',
    method: 'put'
  },
  delete: {
    url: '/api/menu/delete',
    method: 'delete'
  }
}



// WEBPACK FOOTER //
// ./src/api/menu.js